import { render, staticRenderFns } from "./StoryDeleteConfirm.vue?vue&type=template&id=2573de14&"
import script from "./StoryDeleteConfirm.vue?vue&type=script&lang=ts&"
export * from "./StoryDeleteConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports